import { IconProps } from "./types";

export const PhoneIcon = ({
  size = 20,
  color = "currentColor",
  className,
}: IconProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="none"
    className={className}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M9.601 10.41c3.464 3.463 4.25-.543 6.456 1.66 2.126 2.126 3.349 2.552.654 5.245-.337.271-2.481 3.533-10.017-3.999C-.842 5.783 2.42 3.637 2.69 3.3c2.701-2.7 3.12-1.471 5.246.654 2.206 2.205-1.799 2.993 1.665 6.456"
      fill="url(#a)"
    />
    <defs>
      <linearGradient
        id="a"
        x1="10.008"
        y1="1.751"
        x2="10.008"
        y2="18.248"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color={color} />
        <stop offset="1" stop-color={color} />
      </linearGradient>
    </defs>
  </svg>
);
